import {
  cloneAddress,
  normalizeCustomerAddress,
} from "./addressModel";

const KNOWN_COMPANY_SOURCE_ORDER = ["knownCompanies", "supplierCompanies", "publicCompanies"];

export const isInvoiceDeliveryReady = organization =>
  Boolean(organization?.invoiceAddress?.customerId);

export const getAddressSummary = address => {
  if (!address) return "";

  return [
    address.address1 || "",
    [address.zip || "", address.city || ""].filter(Boolean).join(" "),
  ]
    .filter(Boolean)
    .join(", ");
};

export const mergeOrganizationOptions = ({ knownCompanies, publicCompanies, supplierCompanies } = {}) => {
  const byId = new Map();

  const add = (list, source) => {
    (list || []).forEach(organization => {
      const companyId = organization?.companyId;
      if (companyId === undefined || companyId === null) return;

      byId.set(companyId, {
        ...organization,
        source,
      });
    });
  };

  add(knownCompanies, "knownCompanies");
  add(supplierCompanies, "supplierCompanies");
  add(publicCompanies, "publicCompanies");

  return [...byId.values()].sort((a, b) => {
    const aOrder = KNOWN_COMPANY_SOURCE_ORDER.indexOf(a.source);
    const bOrder = KNOWN_COMPANY_SOURCE_ORDER.indexOf(b.source);
    if (aOrder !== bOrder) return aOrder - bOrder;
    return String(a.name || "").localeCompare(String(b.name || ""), "sv");
  });
};

export const getOrganizationCustomerAddresses = organization => {
  const invoiceAddress = normalizeCustomerAddress(
    organization?.invoiceAddress || { name: organization?.name || "" }
  );
  const deliveryAddress = organization?.deliveryAddress
    ? normalizeCustomerAddress(organization.deliveryAddress)
    : cloneAddress(invoiceAddress);

  return {
    invoiceAddress,
    deliveryAddress,
    deliverySameAsBilling: !organization?.deliveryAddress,
  };
};

export const createAddressBaselineFromSource = addressSource => {
  if (!addressSource?.invoiceAddress || !addressSource?.deliveryAddress) {
    return null;
  }

  return {
    invoiceAddress: cloneAddress(addressSource.invoiceAddress),
    deliveryAddress: cloneAddress(addressSource.deliveryAddress),
    deliverySameAsBilling: addressSource.deliverySameAsBilling === true,
  };
};

export const createOrganizationScalarBaseline = organization => {
  if (organization?.companyId === undefined || organization?.companyId === null) {
    return null;
  }

  return {
    organizationId: organization.companyId,
    companyName: organization.name || "",
    organizationNumber: organization.orgNo || "",
    vatNumber: organization.vatRegNo || "",
    contactPerson: organization.invoiceAddress?.contact || "",
    email: organization.invoiceAddress?.email || "",
    telephone: organization.invoiceAddress?.telephone || "",
  };
};

export const createOrganizationAddressBaseline = (
  organization,
  addressSource
) => {
  const fromSource = createAddressBaselineFromSource(addressSource);
  if (fromSource) return fromSource;
  if (!organization) return null;
  return getOrganizationCustomerAddresses(organization);
};

export const createOrganizationBaseline = (organization, addressSource) => {
  const scalar = createOrganizationScalarBaseline(organization);
  if (!scalar) return null;

  return {
    ...scalar,
    ...createOrganizationAddressBaseline(organization, addressSource),
  };
};